import { Component, Injector, OnInit } from "@angular/core";
import { AdaptClientConfiguration } from "@common/configuration/adapt-client-configuration";
import { BaseRoutedComponent } from "@common/ux/base-routed.component";

@Component({
    selector: "adapt-landing-page",
    templateUrl: "./landing-page.component.html",
    standalone: false,
})
export class LandingPageComponent extends BaseRoutedComponent implements OnInit {
    public ProjectLabel = AdaptClientConfiguration.IsCurrentEmbedApiBaseUri
        ? "Lumia"
        : "HQ";

    constructor(injector: Injector) {
        super(injector);
    }

    public ngOnInit() {
        this.notifyActivated();
    }
}
